import React from 'react';
import { 
  Dialog, 
  DialogTitle, 
  DialogContent, 
  Typography, 
  Box, 
  Button, 
  IconButton,
  Divider,
  useTheme
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

function DetailModal({ open, handleClose, data }) {
  const theme = useTheme();
  const isLight = theme.palette.mode === 'light';

  if (!data) return null;

  return (
    <Dialog 
      open={open} 
      onClose={handleClose}
      fullWidth
      maxWidth="md"
      scroll="paper"
      slotProps={{
        backdrop: {
          sx: {
            backgroundColor: isLight
              ? 'rgba(15, 23, 42, 0.6)'
              : 'rgba(0, 0, 0, 0.75)',
            backdropFilter: 'blur(6px)',
            WebkitBackdropFilter: 'blur(6px)',
          },
        },
      }}
      PaperProps={{
        sx: {
          background: isLight ? '#ffffff' : '#0f172a',
          borderRadius: '16px',
          boxShadow: isLight
            ? '0 24px 48px rgba(15, 23, 42, 0.15)'
            : '0 24px 48px rgba(0, 0, 0, 0.5)',
          border: isLight
            ? '1px solid rgba(79, 70, 229, 0.08)'
            : '1px solid rgba(255, 255, 255, 0.06)',
        },
      }}
    >
      <DialogTitle sx={{ 
        pb: 1, 
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start'
      }}>
        <Box>
          <Typography variant="h4" component="h2" color="primary.main">
            {data.title}
          </Typography>
          <Typography variant="subtitle1" sx={{ mt: 1, fontStyle: 'italic' }}>
            {data.subtitle}
          </Typography>
        </Box>
        <IconButton 
          aria-label="close" 
          onClick={handleClose}
          sx={{ mt: -1, mr: -1 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <Divider />
      <DialogContent sx={{ py: 3 }}>
        {data.sections?.map((section, index) => (
          <Box key={index} sx={{ mb: 4 }}>
            <Typography 
              variant="h6" 
              component="h3" 
              color="primary.main"
              gutterBottom
            >
              {section.heading}
            </Typography>
            <Typography variant="body1" sx={{ mb: 2 }}>
              {section.content}
            </Typography>
          </Box>
        ))}
        
        <Box sx={{ mt: 4, textAlign: 'center' }}>
          <Button 
            variant="contained" 
            color="primary"
            size="large"
            onClick={() => {
              data.ctaAction();
              handleClose();
            }}
          >
            {data.ctaText}
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
}

export default DetailModal;